module.exports = __webpack_public_path__ + "img/Karina Theurer.ed09ba54.jpg";